import { render, staticRenderFns } from "./交易指南详情.vue?vue&type=template&id=c37e6b18&scoped=true"
import script from "./交易指南详情.vue?vue&type=script&lang=js"
export * from "./交易指南详情.vue?vue&type=script&lang=js"
import style0 from "./交易指南详情.vue?vue&type=style&index=0&id=c37e6b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37e6b18",
  null
  
)

export default component.exports